import { render, staticRenderFns } from "./DeputySelect.vue?vue&type=template&id=4d4090ac&"
import script from "./DeputySelect.vue?vue&type=script&lang=js&"
export * from "./DeputySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports